import { CaptureStep } from "@idw-types/data/capture-step";
import { CaptureModes } from "@enums/capture-modes";

export enum VerificationStepConfigActionTypes {
    INITIALIZE_VERIFICATION_STEP_CONFIG = "INITIALIZE_VERIFICATION_STEP_CONFIG",
    SET_IS_STARTING_CAPTURE = "SET_IS_STARTING_CAPTURE",
    SET_START_CAPTURE_SUCCESS = "SET_START_CAPTURE_SUCCESS",
    SET_CAPTURE_MODE = "SET_CAPTURE_MODE",
    UPDATE_CAPTURE_STEP = "UPDATE_CAPTURE_STEP",
    SET_SHARPNESS_FAILURE_COUNT = "SET_SHARPNESS_FAILURE_COUNT"
}

type InitializeVerificationStepConfigAction = {
    type: VerificationStepConfigActionTypes.INITIALIZE_VERIFICATION_STEP_CONFIG;
    payload: { captureSteps: Array<CaptureStep> };
};

export const initializeVerificationStepConfig = (captureSteps: Array<CaptureStep>): InitializeVerificationStepConfigAction => ({
    type: VerificationStepConfigActionTypes.INITIALIZE_VERIFICATION_STEP_CONFIG,
    payload: {
        captureSteps
    }
});

type SetIsStartingCaptureAction = {
    type: VerificationStepConfigActionTypes.SET_IS_STARTING_CAPTURE
};

export const setIsStartingCapture = (): SetIsStartingCaptureAction => ({
    type: VerificationStepConfigActionTypes.SET_IS_STARTING_CAPTURE
});

type SetStartCaptureSuccessAction = {
    type: VerificationStepConfigActionTypes.SET_START_CAPTURE_SUCCESS;
    payload: { responseToken: string };
};

export const setStartCaptureSuccess = (responseToken: string): SetStartCaptureSuccessAction => ({
    type: VerificationStepConfigActionTypes.SET_START_CAPTURE_SUCCESS,
    payload: { responseToken }
});

type SetCaptureModeAction = ({
    type: VerificationStepConfigActionTypes.SET_CAPTURE_MODE;
    payload: { captureMode: CaptureModes };
});

export const setCaptureMode = (captureMode: CaptureModes): SetCaptureModeAction => ({
    type: VerificationStepConfigActionTypes.SET_CAPTURE_MODE,
    payload: { captureMode }
});

type UpdateCaptureStepAction = ({
    type: VerificationStepConfigActionTypes.UPDATE_CAPTURE_STEP;
    payload: { captureStep: CaptureStep };
});

export const updateCaptureStep = (captureStep: CaptureStep): UpdateCaptureStepAction => ({
    type: VerificationStepConfigActionTypes.UPDATE_CAPTURE_STEP,
    payload: { captureStep }
});

type SetSharpnessFailureCount = ({
    type: VerificationStepConfigActionTypes.SET_SHARPNESS_FAILURE_COUNT,
    payload: { sharpnessFailureCount: number }
});

export const setSharpnessFailureCount = (sharpnessFailureCount: number): SetSharpnessFailureCount => ({
    type: VerificationStepConfigActionTypes.SET_SHARPNESS_FAILURE_COUNT,
    payload: { sharpnessFailureCount }
});

export type VerificationStepConfigActions =
    InitializeVerificationStepConfigAction |
    SetIsStartingCaptureAction |
    SetStartCaptureSuccessAction |
    SetCaptureModeAction |
    UpdateCaptureStepAction |
    SetSharpnessFailureCount